
export const AlignCenterVertical = ({color="#4E4B66", size=24}: {color?: string, size?: number}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.08398 18V12.6667H6.33398V11.3333H9.08398V6H10.734V11.3333H12.934V8H14.584V11.3333H17.334V12.6667H14.584V16H12.934V12.6667H10.734V18H9.08398Z" fill={color}/>
    </svg>
  );
}